module.exports = __webpack_public_path__ + "a37b0c01c0baf1888ca812cc0508f6e2.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/material-icons/MaterialIcons-Regular.ttf
// module id = 376
// module chunks = 134